module.exports = __webpack_public_path__ + "im-live-list-item-status-19bd2cda.gif";